import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Chip,
  Divider
} from '@mui/material';
import { SurveyExecution } from '../types/survey';

interface ExecutionHistoryProps {
  executions: string[];
  onSelectExecution?: (executionId: string) => void;
  selectedExecutionId?: string;
}

export const ExecutionHistory: React.FC<ExecutionHistoryProps> = ({
  executions,
  onSelectExecution,
  selectedExecutionId
}) => {
  const getStatusColor = (status?: string) => {
    switch (status) {
      case 'completed':
        return 'success';
      case 'running':
      case 'in_progress':
        return 'info';
      case 'fetching_panelists':
        return 'secondary';
      case 'pending':
        return 'warning';
      case 'failed':
        return 'error';
      case 'partial':
        return 'warning';
      default:
        return 'default';
    }
  };

  if (executions.length === 0) {
    return (
      <Paper elevation={2} sx={{ p: 3 }}>
        <Typography variant="h6" color="primary" fontWeight={600} gutterBottom>
          Recent Executions
        </Typography>
        <Typography variant="body2" color="text.secondary">
          No executions yet. Start a new survey execution above.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <Typography variant="h6" color="primary" fontWeight={600} gutterBottom>
        Recent Executions
      </Typography>
      <List disablePadding>
        {executions.map((executionId, index) => (
          <React.Fragment key={executionId}>
            {index > 0 && <Divider />}
            <ListItem disablePadding>
              <ListItemButton
                selected={executionId === selectedExecutionId}
                onClick={() => onSelectExecution && onSelectExecution(executionId)}
              >
                <ListItemText
                  primary={
                    <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                      {executionId}
                    </Typography>
                  }
                  secondary="Click to view status"
                />
              </ListItemButton>
            </ListItem>
          </React.Fragment>
        ))}
      </List>
    </Paper>
  );
};

export default ExecutionHistory;

